export default __webpack_public_path__ + "static/media/DENTISTCERTIFICATE.bbeb1d0c.png";